import {
    InputContext,
    inputContextToColor,
} from '../../../../dg-web-shared/tb-ui/inputs/InputContext';
import { css } from '@emotion/css';
import { Colors } from 'dg-web-shared/ui/vars.ts';
import {
    Underline,
    UnderlineStatus,
} from '../../../../dg-web-shared/tb-ui/inputs/internal/Underline.tsx';
import { Label } from '../../../../dg-web-shared/tb-ui/inputs/internal/Label.tsx';
import { Clickable } from 'dg-web-shared/ui/Clickable.tsx';
import { InputError } from '../../../../dg-web-shared/tb-ui/inputs/internal/InputError.tsx';
import { Typo } from 'dg-web-shared/ui/typo.ts';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';

const itemStyle = (isSelected: boolean, styleContext: InputContext) => {
    return css({
        ...Typo.body,
        ...(isSelected
            ? {
                  color: `${Colors.rgba(inputContextToColor(styleContext), 1)}`,
                  borderBottom: `solid 1px ${Colors.rgba(
                      inputContextToColor(styleContext),
                      1,
                  )}`,
                  display: 'inline-block',
                  fontWeight: 400,
              }
            : {
                  color: `${Colors.rgba(
                      inputContextToColor(styleContext),
                      0.6,
                  )}`,
                  borderBottom: `solid 1px ${Colors.rgba(
                      inputContextToColor(styleContext),
                      0,
                  )}`,
              }),
    });
};

interface GenderSelectProps {
    gender: 'm' | 'f' | null | undefined;
    underlineStatus: UnderlineStatus;
    errorText: string;
    styleContext: InputContext;
    writeGender: (gender: 'm' | 'f') => void;
}

export const GenderSelect = (p: GenderSelectProps) => {
    return (
        <div
            className={css({
                marginTop: '8px',
            })}
        >
            <Label
                context={p.styleContext}
                elevated={true}
                text={
                    <Localized de="Anrede" fr="Titre" it="Titolo" en="Gender" />
                }
            />
            <div
                className={css({
                    display: 'flex',
                })}
            >
                <div
                    className={css({
                        flex: 1,
                    })}
                >
                    <Clickable
                        element="div"
                        className={itemStyle(p.gender === 'f', p.styleContext)}
                        onClick={() => p.writeGender('f')}
                    >
                        <Localized de="Frau" fr="Madame" it="Signora" en="Ms" />
                    </Clickable>
                </div>
                <div
                    className={css({
                        flex: 1,
                    })}
                >
                    <Clickable
                        element="div"
                        className={itemStyle(p.gender === 'm', p.styleContext)}
                        onClick={() => p.writeGender('m')}
                    >
                        <Localized
                            de="Herr"
                            fr="Monsieur"
                            it="Signor"
                            en="Mr"
                        />
                    </Clickable>
                </div>
            </div>
            <Underline status={p.underlineStatus} context={p.styleContext} />
            <InputError context={p.styleContext} text={p.errorText} />
        </div>
    );
};
